import { render, staticRenderFns } from "./helpWhite.vue?vue&type=template&id=4a00a916&"
import script from "./helpWhite.vue?vue&type=script&lang=ts&"
export * from "./helpWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports